import { BehaviorSubject, Subject } from 'rxjs';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScrollBarService {
  // private _scrollbars = [];
  public scrolled = new Subject<any>();
  public scrollTo = new Subject<any>();
  constructor() {}

  // register(id) {
  //     if(this._scrollbars.indexOf(id) === -1){
  //         this._scrollbars.push(id);
  //     }
  // }

  // unregister(id) {
  //     const index = this._scrollbars.indexOf(id);
  //     if(index > -1){
  //         this._scrollbars.push(id);
  //     }
  // }

  notify($event, id, rect) {
    this.scrolled.next({ id: id, event: $event, rect: rect });
  }
}
